import AttachmentItemsSort from 'owa-service/lib/contract/AttachmentItemsSort';
import AttachmentItemsSortColumn from 'owa-service/lib/contract/AttachmentItemsSortColumn';
import AttachmentItemsSortOrder from 'owa-service/lib/contract/AttachmentItemsSortOrder';

export const defaultSort: AttachmentItemsSort = Object.freeze({
    SortColumn: AttachmentItemsSortColumn.LastModified,
    SortOrder: AttachmentItemsSortOrder.Descending,
});

export const GDRIVE_FILE_PICKER_FETCH_ITEMS_PARAMS =
    'maxResults=1000&fields=nextPageToken,files(id,mimeType,name,size,modifiedTime,thumbnailLink,webViewLink,webContentLink,createdTime,fileExtension)';

export const GDriveDataProviderItemType: string = 'GDriveDataProviderItem:#Exchange';

export const FacebookDataProviderItemType: string = 'FacebookDataProviderItem:#Exchange';
export const FacebookProviderScopeType: string = 'FacebookProviderScope:#Exchange';
export const FileAttachmentDataProviderItemType: string =
    'FileAttachmentDataProviderItem:#Exchange';
export const FolderAttachmentDataProviderItemType: string =
    'FolderAttachmentDataProviderItem:#Exchange';
export const OneDriveProScopeName: string = 'OneDriveProScope:#Exchange';
export const OneDriveProItemsSkipTokenPagingMetadataType: string =
    'OneDriveProItemSkipTokenPagingMetadata:#Client';
export const OneDriveConsumerScopeName: string = 'OneDriveConsumerScope:#Exchange';

export const ScopeBreadcrumbId: string = 'scopeId';
export const SearchBreadcrumbId: string = 'searchId';
export const SizeLimitInKbToSuggestSharing: number = 5 * 1024;

export const OneDriveOneNoteType = 'oneNote';

export const OneNoteMimeType = 'application/onenote';
